import {
  GET_ADMIN_ACCESS_FAIL,
  GET_ADMIN_ACCESS_REQUEST,
  GET_ADMIN_ACCESS_SUCCESS,
} from '../actions/adminAccess';

const initialState = {
  adminAccess: null,
  loading: false,
  error: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ADMIN_ACCESS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case GET_ADMIN_ACCESS_SUCCESS: {
      return {
        ...state,
        adminAccess: action.payload,
        loading: false,
        error: false,
      };
    }
    case GET_ADMIN_ACCESS_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    default: {
      return state;
    }
  }
}

